<template>
    <div class="page-detail" v-if="myUid">
        <div class="ta-center">
              <img v-if="isInMobile" src="../../assets/img/ad2.png" width="80%" alt="">
              <img v-else src="../../assets/img/ad-pc.png" width="80%" alt="">
        </div>
         <k-hr size="20"/>
        <div>
            <my-timer></my-timer>
        </div>
        <k-hr size="20"/>
        <div class="box">
            <ul>
                <li>1. 截止2019年10月31日15:00之前，草根值达到1万的用户将自动升级为终身黄金会员；</li>
                <li>2. 自2019年11月1日起，新黄金会员身份需按年购买，且有效期为1年，不再享受老会员的终身制；</li>
                <li>3. 【王者点金】仅限黄金会员及以上购买 <a :href="djUrl" class="cl-yel">[点击查看]</a>；</li>
                <li> <strong>等级说明：白银→黄金→钻石→至尊 <a href="/user/level/index/#/index" class="cl-yel">[点击查看]</a>；</strong></li>
            </ul>
        </div>
        <k-hr size="50"/>
        <div class="box">
            <my-info></my-info>
        </div>
        <div class="box">
            <hexun></hexun>
        </div>
        <div class="box">
            <sina></sina>
        </div>
        <div class="box">
            <goods></goods>
        </div>
        <kefu></kefu>
        
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import { WZ } from '../../common/globals'
    import User from './mod/user'
    import Hexun from './mod/hexun'
    import Sina from './mod/sina'
    import Goods from './mod/goods'
    import Kefu from './mod/kefu'
    import Timer from '../mod/timer'
    import { isInMobile } from '../../utils/base'
    const ClipboardJS = window.ClipboardJS
    export default {
        data() {
            return {
                isInMobile : isInMobile()
            }
        },
        components:{
            'my-info' : User,
            'hexun' : Hexun,
            'sina' : Sina,
            'goods' : Goods,
            'kefu' : Kefu,
            'my-timer' : Timer
        },
        computed: {
            ...mapState(['timeStatus','timeText']),            
            ...mapGetters(['myUid', 'myLogo', 'myNick']),
            ...mapState('exp',['isHexun']),
            ...mapState(['timeStatus','timeText']),
            ...mapState('config', ['wzConfig']),
            djUrl(){
                return this.wzConfig?this.wzConfig.djUrl : 'javascript;'
            }
        },
        methods: {
            ...mapActions('exp', ['hxInfo','sourceExp','getLeveInfo']),
            ...mapActions('account', ['load']),
            clipboard(){
                let self = this
                var clipboard = new ClipboardJS('.wx-code')
                clipboard.on('success', function() {
                    self.$toast('复制成功')
                    //e.clearSelection()
                })

                clipboard.on('error', function() {
                    self.$toast('复制失败，请手动复制')
                })
            }
        },
        async created(){
            try{
                await this.load()
                
            }catch (err){
                console.log(err)
            }
            if(!this.myUid){
                WZ.go('login')
            }
            this.getLeveInfo()
        },
        mounted() {
            this.clipboard()
        },
        watch: {
            timeStatus(n){
                if(n===0){
                    this.$router.push({path:'/'})
                }
            }
        },
    }
</script>